/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector, useDispatch } from 'react-redux'
import { useCookies } from 'react-cookie'
import { useNavigate, useParams } from 'react-router-dom';
import {
  setAuthen,
  setBizID,
  setStyle,
  setLogo,
  setRoles,
  setBusinessName,
  getRoles as getReduxRole,
  setCurrentRole,
  getCurrentRole,
  setFile,
  setMemberFail,
  setMemberSuccess,
  setServices,
  getServices,
  getOpenSidebar,
  setOpenSidebar,
} from '../libs/todoSlice'
import axios from 'axios';
import { Outlet } from "react-router-dom";
import Cookie from '../lib/Cookie';
import LoadingComponent from '../lib/LoadingComponent';
import { Dialog } from 'primereact/dialog';
import ThemeColor from "./dropdown/Theme";
import { getTricker, setImportModal, setManageMemberStep } from '../libs/sideBarSlice';
import './Navbar.css'
import Sidebar from './Sidebar.jsx';
import { logoutSession } from '../lib/logoutRedirect';
import Address from '../lib/Address';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export default function Navbar() {
  const navigate = useNavigate()
  const params = useParams()
  const roles = useSelector(getReduxRole)
  const currentRole = useSelector(getCurrentRole)
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch()
  const [dialogTheme, setDialogTheme] = useState(false);

  const [account, setAccount] = useState(null);
  const open = useSelector(getOpenSidebar)
  const setOpen = (action) => {
    dispatch(setOpenSidebar({
      openSidebar: action
    }))
  }
  const [width] = useState(window.innerWidth);
  useState(() => {
    if (width > '768') {
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [width])

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  // alert(auth)
  const [cookie, setCookie, removeCookie] = useCookies(['account', 'remember'])
  useEffect(() => {
    // Session is checked by AuthenticateRoute
  }, []);
  useEffect(() => {
    getPrefixDetail()
    setAccount(JSON.parse(localStorage.getItem('account')))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const login = () => {
    navigate(`/${params.prefix}`)
  };

  const getPrefixDetail = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/prefix?prefix=${params.prefix}`,
      })
      if (!data.data) {
        navigate('/notfound')
      } else {
        dispatch(setBizID({
          biz_id: data.data.businessID
        }))
        dispatch(setStyle({
          style: data.data.themes.style
        }))
        // data.data.services.push('edu-student-pre-register-combine')
        // data.data.services = data.data.services.filter(m => m !== 'edu-student-pre-register');

        if (data.data.services) {
          if (data.data.services.includes('edu-student-pre-register-combine')) {
            if (!data.data.services.includes('edu-student-pre-register')) {
              const updatedServices = [...data.data.services, 'edu-student-pre-register'];
              dispatch(setServices({
                services: updatedServices
              }));
            } else {
              dispatch(setServices({
                services: data.data.services
              }));
            }
          } else {
            dispatch(setServices({
              services: data.data.services
            }))
          }
        } else {

        }
      }
      getDataLogo(data.data.businessID)
      getRoles(data.data.businessID)
      getBusinessName(data.data.businessID)
    } catch (err) {
      const status = err?.response?.status
      console.log('[Navbar.getPrefixDetail] failed', {
        status,
        prefix: params.prefix,
        pathname: window.location.pathname,
      })
      if (status === 401) {
        localStorage.removeItem('account')
      }
    }
  }


  const getRoles = async (bizid) => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/roles?business_id=${bizid}`,
      })
      if (!data.data || data.data.length === 0) {
        navigate('/notfound')
      } else {
        dispatch(setRoles({
          roles: data.data
        }))
        dispatch(setCurrentRole({
          current_role: data.data.includes('RA') ? 'RA' : data.data.includes('owner') ? 'owner' : data.data[0]
        }))
      }
    } catch (err) {
      const status = err?.response?.status
      console.log('[Navbar.getRoles] failed', {
        status,
        prefix: params.prefix,
        pathname: window.location.pathname,
      })
      if (status === 401) {
        localStorage.removeItem('account')
      }
      if (status === 403) {
        navigate('/forbidden')
      }
    }
  }
  const getDataLogo = async (bizid) => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/logo?business_id=${bizid}`,
      })
      dispatch(setLogo({
        logo: data.data
      }))
    } catch (err) {
      const status = err?.response?.status
      console.log('[Navbar.getDataLogo] failed', {
        status,
        prefix: params.prefix,
        pathname: window.location.pathname,
      })
      if (status === 401) {
        localStorage.removeItem('account')
      }
    }
  }

  const getBusinessName = async (bizid) => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/ra/biz-name?business_id=${bizid}`,
      })
      dispatch(setBusinessName({
        business_name: data.data.businessName
      }))
    } catch (err) {
      const status = err?.response?.status
      console.log('[Navbar.getBusinessName] failed', {
        status,
        prefix: params.prefix,
        pathname: window.location.pathname,
      })
      if (status === 401) {
        localStorage.removeItem('account')
      }
    }
  }


  const logout = async () => {
    await logoutSession({
      removeCookie,
      dispatch,
      oauth: cookie.oauth,
      prefix: params.prefix,
    })
  };


  const tricker = useSelector(getTricker)
  useEffect(() => {
    if (!tricker) return

    const targetPath = `/${params.prefix}/manage-members`
    if (window.location.pathname === targetPath) {
      console.log('[Navbar] skip tricker redirect because already on target path', { targetPath, currentPath: window.location.pathname })
      return
    }

    console.log('[Navbar] tricker redirect to manage-members', { targetPath, currentPath: window.location.pathname })
    navigate(targetPath)
    dispatch(setFile({
      filename: '',
      file: [],
      file_id: ''
    }))
    dispatch(setMemberFail({
      member_fail: []
    }))
    dispatch(setMemberSuccess({
      member_success: []
    }))
    dispatch(setManageMemberStep({
      manageMemberStep: 'manage_member'
    }))
    dispatch(setImportModal({
      importModal: false
    }))
  }, [tricker, params.prefix, navigate]);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseDialog = () => {
    setAnchorEl(null);
  };

  const ColoredLine = ({ color }) => (
    <hr
      style={{
        color: color,
        backgroundColor: color,
        height: '32px',
        width: '1px',
      }}
    />
  );


  const [role, setRole] = React.useState('');
  useEffect(() => {
    if (roles.length !== 0) {
      setRole(roles[0]);
    }
  }, [roles])

  useEffect(() => {
    if (cookie.remember && localStorage.getItem('account')) {
      refreshToken()
    }
  }, [])

  const refreshToken = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/auth/exchange/token`,
      })
    } catch ({ response }) {
      if (process.env.REACT_APP_ENV === 'production' && response.status === 401) {
        logout()
      }
    }
  }
  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {!account ? '' :
        <AppBar
          position="fixed"
          open={open}
          style={{
            backgroundColor: '#F8F9FA',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
            color: 'black',
            height: '56px',
          }}
        >
          <Toolbar>
            {account &&
              <IconButton
                size="large"
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(open && { display: 'none' }) }}
              >
                <MenuIcon />
              </IconButton>
            }
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>

            </Typography>
            <div className='d-none d-sm-block ' style={{ display: 'contents' }} >
              {!account ? '' :
                <>
                  <span>Role: </span>
                  <FormControl>
                    <Select
                      id="role-select"
                      // disabled
                      value={role}
                      onChange={(e) => {
                        setRole(e.target.value);
                        dispatch(setCurrentRole({
                          current_role: e.target.value
                        }))
                      }}
                      displayEmpty
                      style={{
                        width: '130px',
                        height: '32px',
                        margin: '0 15px 0 5px',
                        backgroundColor: 'white',
                      }}
                    >
                      {roles.map((role, key) =>
                        <MenuItem value={role} key={key}>{role}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </>
              }
            </div>
            <div className='d-none d-sm-block ' style={{ display: 'contents' }} >
              <ColoredLine color="#b3b3b3" />
            </div>
            <div>
              {!account ?
                <AccountCircle />
                :
                <img
                  src={`${process.env.REACT_APP_ONE_ID}/api/get_avatar/${account.id}`}
                  alt="Profile"
                  style={{
                    borderRadius: '100%',
                    maxWidth: '40px',
                    width: '40px',
                    height: '40px',
                    objectFit: 'contain',
                    maxHeight: '40px',
                    margin: '10px',
                  }} />
              }
              {account && <>{account.special_title_name_th || account.account_title_th || ''} {account.first_name_th} {account.last_name_th}</>}
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
              >
                <ArrowDropDownIcon />
              </IconButton>

              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                keepMounted
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                style={{ top: '30px' }}
              >
                {!account && <MenuItem onClick={login}>Login</MenuItem>}

                {account && (currentRole === 'RA' || currentRole === 'owner') && (
                  <MenuItem
                    onClick={() => {
                      window.open(process.env.REACT_APP_BUSINESS_ID_URL, '_blank');
                    }}
                  >
                    จัดการบัญชีนิติบุคคล
                  </MenuItem>
                )}

                {account && (currentRole === 'RA' || currentRole === 'owner') && (
                  <MenuItem
                    onClick={() => {
                      handleCloseDialog();
                      setDialogTheme(true);
                    }}
                  >
                    ออกแบบสีระบบ
                  </MenuItem>
                )}

                {account && (currentRole === 'RA' || currentRole === 'owner') && (
                  <MenuItem
                    onClick={() => {
                      handleCloseDialog();
                      navigate(`/${params.prefix}/home-email`);
                    }}
                  >
                    ตั้งค่าอีเมล
                  </MenuItem>
                )}

                {account && (currentRole === 'RA' || currentRole === 'owner') && (
                  <MenuItem
                    onClick={() => {
                      handleCloseDialog();
                      dispatch(setBizID({ biz_id: null }));
                      navigate(`/businesses/management`);
                    }}
                  >
                    เปลี่ยนบัญชีนิติบุคคล
                  </MenuItem>
                )}

                {account && <MenuItem onClick={logout}>ออกจากระบบ</MenuItem>}
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      }

      <Dialog
        visible={dialogTheme}
        onHide={() => { setDialogTheme(false) }}
        dismissableMask={true}
        draggable={false}
      >
        <ThemeColor />
      </Dialog>

      <Sidebar />
      <Main
        open={open}
        style={{
          // maxHeight: '100vh',
          width: open ?
            width >= '768' ? '65vw' : ''
            :
            '100vw',
          backgroundColor: '#F8F9FA'
        }}
      >
        <DrawerHeader />
        {roles.length !== 0 ? <Outlet /> : <LoadingComponent />}

      </Main>
    </Box>
  );
}
